module.exports = __webpack_public_path__ + "static/barack-obama-271521258b8747505c46fc2180b97908.jpg";